import { Injectable } from '@angular/core';
import { ChangePassengerSolicitudeStatusCommand } from './command/changePassengerSolicitudeToPending.command';
import { MultiRegionService } from '../multiregion/multiregion.service';
import { ErrorsEnum } from '../enum/errors.enum';
import { EditPassengerUserCommand, IEditPassengerUserParameters } from './command/editPassagerUser.command';
import { IdentityService } from '../authentication/identity.service';
import { GetPassengerCreditCardsCommand } from './command/get-passenger-credit-cards.command';
import { GetPassengerByIdCommand, IGetPassengerByIdParameters } from './command/getPassengerById.command';
import { GetPassengerSmallestComand } from './command/get-passengerSmallest-for-combo';
import { getPassengerDriversCommand } from './command/getPassengerDrivers.command';
import { PostPassengerBlockedDriversCommand, PostPassengerFavoriteDriversCommand } from './command/postPassengerBlockedDrivers.command';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { PassengerSmallestResponseDto, PassengerResponseDTO, IAddPassengerUserRequestDto, UploadPassengerFavoriteBlockedDriversResponseDto } from '../authentication/connection/interfaces/apiInterfaces';
import { NotificationsService } from "../notifications/notifications.service";

@Injectable()
export class PassengerService {
  private titleMessage: string;

  constructor(
    private _connectionService: ConnectionServices,
    private _notificationsService: NotificationsService,
    // private _notificationsService: NotificationsService,
    private _multiregionService: MultiRegionService,
    private _identityService: IdentityService
  ) {
    this.titleMessage = 'toast.clients.passenger';
  }

  // public changeSolicitudeToPending(
  //   id: number,
  //   token: string
  // ): Observable<boolean> {
  //   let statusCommand = new ChangePassengerSolicitudeStatusCommand(id, token);
  //   return this._connectionService
  //     .Request(statusCommand)
  //     .map(data => {
  //       return true;
  //     })
  //     .catch(error => {
  //       this._notificationsService.showHttpErrorMessage('toast.authentication.confirmation', error);
  //       return Observable.throw(error);
  //     });
  // }
  public editPassagerUser(
    passengerUserId: number,
    passengerUserRequestDto: IAddPassengerUserRequestDto,
    fareId?: number
  ): Observable<PassengerResponseDTO> {

    let addPassengerCommand = new EditPassengerUserCommand();
    addPassengerCommand.setParameters(<IEditPassengerUserParameters>{
      country: passengerUserRequestDto.country,
      firstName: passengerUserRequestDto.firstName,
      lastName: passengerUserRequestDto.lastName,
      email: passengerUserRequestDto.email,
      phone: passengerUserRequestDto.phone,
      password: passengerUserRequestDto.password,
      addresses: passengerUserRequestDto.addresses,
      passengerUserId: passengerUserId,
      carrierId: this._identityService.userId,
      family: passengerUserRequestDto.family,
      enableFamilyGroup: passengerUserRequestDto.enableFamilyGroup,
      acceptSimultaneousTrip: passengerUserRequestDto.acceptSimultaneousTrip,
      fareId: fareId,
      familyGroupId: passengerUserRequestDto.familyGroupId,
      isPaxVip: passengerUserRequestDto.isPaxVip
    });

    return this._connectionService
      .Request(addPassengerCommand)
      .pipe(
        map(data => {
          this._notificationsService.showSuccessMessage(
            'toast.users.title',
            'toast.shared.message.successful_message_modify'
          );
          return data as any;
        }),
        catchError(error => {
          if (error.status === 409) {
            let message = '';
            if (error.error.errorCode === ErrorsEnum.MAIL_UNIQUE) {
              message = 'toast.users.error_code.mail_unique';
            } else {
              message = 'toast.users.error_code.phone_unique';
            }
            this._notificationsService.showInternalErrorMessage(
              'toast.users.title',
              message
            );
          } else {
            this._notificationsService.showHttpErrorMessage('toast.users.title', error);
          }

          return throwError(() => false);
        })
      );
  }
  // public getPassengerCreditCards(
  //     passengerId: number,
  //     appId: number
  // ): Observable<ICardDetailResponseDTO[]> {
  //   const creditCardsCommand = new GetPassengerCreditCardsCommand();
  //   creditCardsCommand.setParameters({
  //     passengerId: passengerId,
  //     appId: appId
  //   });

  //   return this._connectionService
  //       .Request(creditCardsCommand)
  //       .map(response => {
  //         return response;
  //       })
  //       .catch(error => {
  //         // this._notificationsService.showHttpErrorMessage('toast.users.title', error);
  //         return Observable.throw(false);
  //       });
  // }

  getPassengerById(passengerId: number, carrierId?: number) {
    const command = new GetPassengerByIdCommand();

    command.setParameters(<IGetPassengerByIdParameters>{
      idPassenger: passengerId,
      idCarrier: carrierId,
    });

    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          const response = data as any;
          return response;
        }),
        catchError((err) => {
          return throwError(err);
        })
      )
    // return this._connectionService
    //   .Request(command)
    //   .map(response => {
    //     return response;
    //   })
    //   .catch(error => {
    //     // this._notificationsService.showHttpErrorMessage('toast.users.title', error);
    //     return Observable.throw(false);
    //   });
  }

  findFamilyGroupForCombo(terms: string): Observable<PassengerSmallestResponseDto[]> {
    const command = new GetPassengerSmallestComand();
    command.setParameters({
      carrierId: this._identityService.userId,
      name: terms
    });
    if (terms.length < 3) {
      return;
    }
    return this._connectionService
      .Request(command)
      .pipe(
        map(data => {
          const response = data as PassengerSmallestResponseDto[];
          return response;
        }),
        catchError((err) => {
          return throwError(err);
        })
      )
  }

  getPaxDrivers(passengerId: number) {
    const command = new getPassengerDriversCommand();
    command.setParameters({
      carrierId: Number(this._identityService.userId),
      passengerUserId: passengerId
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          console.log(error);
          // this._notificationsService.showHttpErrorMessage('Error', error.message);
          return throwError(() => false);
        })
      );
  }

  uploadPassengerFavoriteBlockedDrivers(
    passengerId: number,
    drivers: number[],
    favorite?: boolean
  ): Observable<UploadPassengerFavoriteBlockedDriversResponseDto> {
    const command = favorite ? new PostPassengerFavoriteDriversCommand() : new PostPassengerBlockedDriversCommand();
    command.setParameters({
      carrierId: Number(this._identityService.userId),
      passengerId,
      driverIds: drivers
    });
    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(error => {
          console.log(error);
          this._notificationsService.showHttpErrorMessage('Error', error.message);
          return throwError(() => false);
        })
      );
  }
}
